<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar v-if="this.paymentData.tranMode !== 'R'" dense color="grey lighten-3" flat>
              <v-icon>mdi-plus</v-icon>
              <v-toolbar-title>Create New Payment</v-toolbar-title>
            </v-toolbar>
            <v-toolbar v-if="this.paymentData.tranMode === 'R'" dense color="grey lighten-3" flat>
              <v-icon>mdi-pencil</v-icon>
              <v-toolbar-title>Edit Payment </v-toolbar-title>
            </v-toolbar>
            <v-tabs v-model="tabNav">
              <v-tab @click.native="doMandatory(0)">Mandatory</v-tab>
              <v-tab @click.native="doOptional(1)">Optional</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabNav" touchless>
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="mandatory" eager>
                <form data-vv-scope="paymentMandatoryForm">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md6 xs12>
                              <v-autocomplete
                                :items="branches"
                                v-model="paymentForm.branch"
                                :label="paymentFormLabel.branch"
                                item-text="label"
                                item-value="value"
                                data-vv-name="paymentForm.branch"
                                :data-vv-as="paymentFormLabel.branch"
                                :error-messages="errors.collect('paymentForm.branch')"
                                clearable
                                v-validate="'required'"
                                :disabled="this.paymentData.tranMode === 'R'"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md2 xs12 v-if="this.paymentData.tranMode !== 'R'">
                              <v-checkbox
                                color="primary"
                                :label="paymentFormLabel.docAE"
                                v-model="paymentForm.docAE"
                                @change="checkDocAE($event)"
                                :disabled="this.paymentData.tranMode === 'R'"
                              ></v-checkbox>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="paymentForm.documentNo"
                                :disabled="isDisabledDocNo || this.paymentData.tranMode === 'R'"
                                :label="paymentFormLabel.documentNo"
                                :error-messages="errors.collect('paymentForm.documentNo')"
                                data-vv-name="paymentForm.documentNo"
                                :data-vv-as="paymentFormLabel.documentNo"
                                @blur="checkDocNo"
                                v-validate="docNoValidation"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md6 xs12>
                              <cal-picker
                                v-model="paymentForm.transactionDate"
                                :label="paymentFormLabel.transactionDate"
                                :data-vv-as="paymentFormLabel.transactionDate"
                                data-vv-name="paymentForm.transactionDate"
                                :error-messages="errors.collect('paymentForm.transactionDate')"
                                v-validate="doValidateTranDate"
                                :loading="loading"
                              ></cal-picker>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-autocomplete
                                :items="accounts"
                                v-model="paymentForm.payTo"
                                item-text="label"
                                item-value="value"
                                :label="paymentFormLabel.payTo"
                                :error-messages="errors.collect('paymentForm.payTo')"
                                data-vv-name="paymentForm.payTo"
                                :data-vv-as="paymentFormLabel.payTo"
                                v-validate="'required'"
                                @change="getPayToAcctInfo($event)"
                                clearable
                                :disabled="this.paymentData.tranMode === 'R'"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon
                                    color="info"
                                    @click="showPayToHelpList = true"
                                    :disabled="this.paymentData.tranMode === 'R'"
                                  >mdi-magnify</v-icon>
                                </v-slide-x-reverse-transition>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex md5 xs12>
                              <v-autocomplete
                                :items="banks"
                                v-model="paymentForm.fromBank"
                                item-text="label"
                                item-value="value"
                                :label="paymentFormLabel.fromBank"
                                :error-messages="errors.collect('paymentForm.fromBank')"
                                data-vv-name="paymentForm.fromBank"
                                :data-vv-as="paymentFormLabel.fromBank"
                                v-validate="'required'"
                                @change="getBankInfo($event)"
                                clearable
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="showBankNoHelpList = true">mdi-magnify</v-icon>
                                </v-slide-x-reverse-transition>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex md2 xs12>
                              <v-autocomplete
                                :items="funds"
                                v-model="paymentForm.fund"
                                :label="paymentFormLabel.fund"
                                item-text="label"
                                item-value="value"
                                data-vv-name="paymentForm.fund"
                                :data-vv-as="paymentFormLabel.fund"
                                :error-messages="errors.collect('paymentForm.fund')"
                                disabled
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md5 xs12>
                              <v-autocomplete
                                :items="acctnosuffixes"
                                v-model="paymentForm.accountNoSuffix"
                                item-text="label"
                                item-value="value"
                                :label="paymentFormLabel.accountNoSuffix"
                                :error-messages="errors.collect('paymentForm.accountNoSuffix')"
                                data-vv-name="paymentForm.accountNoSuffix"
                                :data-vv-as="paymentFormLabel.accountNoSuffix"
                                v-validate="'required|entry|max:60'"
                                @change="getAcctNoSfxInfo($event)"
                                clearable
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="showAcctSufHelpList = true">mdi-magnify</v-icon>
                                </v-slide-x-reverse-transition>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex md5 xs12>
                              <v-autocomplete
                                :items="gstIO"
                                v-model="paymentForm.gstIO"
                                :label="paymentFormLabel.gstIO"
                                item-text="label"
                                item-value="value"
                                data-vv-name="gstIO"
                                :data-vv-as="paymentFormLabel.gstIO"
                                :error-messages="errors.collect('gstIO')"
                                @change="changeGstIO($event)"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="gstStatuses"
                                v-model="paymentForm.gstStatus"
                                :label="paymentFormLabel.gstStatus"
                                item-text="label"
                                item-value="value"
                                data-vv-name="gstStatus"
                                :data-vv-as="paymentFormLabel.gstStatus"
                                :error-messages="errors.collect('gstStatus')"
                                @change="changeGstRate($event)"
                                :disabled="isBlankGSTIO"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md3 xs12>
                              <v-text-field
                                v-model="paymentForm.gstRate"
                                :label="paymentFormLabel.gstRate"
                                disabled
                                hide-details:error-messages="errors.collect('paymentForm.gstRate')"
                                data-vv-name="paymentForm.gstRate"
                                :data-vv-as="paymentFormLabel.gstRate"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="amountcurrencies"
                                v-model="paymentForm.amountCurr"
                                :label="paymentFormLabel.amountCurr"
                                item-text="label"
                                item-value="value"
                                :error-messages="errors.collect('paymentForm.amountCurr')"
                                data-vv-name="paymentForm.amountCurr"
                                :data-vv-as="paymentFormLabel.amountCurr"
                                v-validate="'required'"
                                :disabled="this.payBankCurr === true"
                                clearable
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="showCurrencyHelpList = true">mdi-magnify</v-icon>
                                </v-slide-x-reverse-transition>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex md8 xs12>
                              <v-text-field
                                ref="amount"
                                v-model="paymentForm.amount"
                                :label="paymentFormLabel.amount"
                                :error-messages="errors.collect('paymentForm.amount')"
                                data-vv-name="paymentForm.amount"
                                :data-vv-as="paymentFormLabel.amount"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'required|mask_decimal:2|mask_max_value:9999999999999.99|mask_min_value:0.01'"
                                @blur="calculateAmount()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="paymentForm.gstAmountCurr"
                                :label="paymentFormLabel.gstAmountCurr"
                                :disabled="true"
                                item-text="label"
                                item-value="value"
                                data-vv-name="paymentForm.gstAmountCurr"
                                :data-vv-as="paymentFormLabel.gstAmountCurr"
                                :error-messages="errors.collect('paymentForm.gstAmountCurr')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md1 xs12>
                              <v-checkbox
                                color="primary"
                                :label="paymentFormLabel.gstAmountAE"
                                :disabled="isGstAmtAE"
                                v-model="paymentForm.gstAmountAE"
                                @change="calculateAmount()"
                              ></v-checkbox>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-text-field
                                ref="gstAmount"
                                v-model="paymentForm.gstAmount"
                                :label="paymentFormLabel.gstAmount"
                                :disabled="isGstAmt"
                                :error-messages="errors.collect('paymentForm.gstAmount')"
                                data-vv-name="paymentForm.gstAmount"
                                :data-vv-as="paymentFormLabel.gstAmount"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'mask_decimal:2|mask_max_value:9999999999999.99'"
                                @blur="calculateAmount()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="paymentForm.netAmountCurr"
                                :label="paymentFormLabel.netAmountCurr"
                                :disabled="true"
                                item-text="label"
                                item-value="value"
                                data-vv-name="paymentForm.netAmountCurr"
                                :data-vv-as="paymentFormLabel.netAmountCurr"
                                :error-messages="errors.collect('paymentForm.netAmountCurr')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md8 xs12>
                              <v-text-field
                                v-model="paymentForm.netAmount"
                                :label="paymentFormLabel.netAmount"
                                :disabled="true"
                                :error-messages="errors.collect('paymentForm.netAmount')"
                                data-vv-name="paymentForm.netAmount"
                                :data-vv-as="paymentFormLabel.netAmount"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="paymentForm.bankAmountCurr"
                                :label="paymentFormLabel.bankAmountCurr"
                                :disabled="true"
                                item-text="label"
                                item-value="value"
                                data-vv-name="paymentForm.bankAmountCurr"
                                :data-vv-as="paymentFormLabel.bankAmountCurr"
                                :error-messages="errors.collect('paymentForm.bankAmountCurr')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md1 xs12>
                              <v-checkbox
                                color="primary"
                                :label="paymentFormLabel.bankAmountAE"
                                v-model="paymentForm.bankAmountAE"
                                @change="calculateAmount()"
                              ></v-checkbox>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-text-field
                                ref="bankAmount"
                                v-model="paymentForm.bankAmount"
                                :label="paymentFormLabel.bankAmount"
                                :disabled="isBankAmt"
                                :error-messages="errors.collect('paymentForm.bankAmount')"
                                data-vv-name="paymentForm.bankAmount"
                                :data-vv-as="paymentFormLabel.bankAmount"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'mask_decimal:2|mask_max_value:9999999999999.99'"
                                @blur="calculateAmount()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="paymentForm.bankChargesCurr"
                                :label="paymentFormLabel.bankChargesCurr"
                                disabled
                                item-text="label"
                                item-value="value"
                                data-vv-name="paymentForm.bankChargesCurr"
                                :data-vv-as="paymentFormLabel.bankChargesCurr"
                                :error-messages="errors.collect('paymentForm.bankChargesCurr')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md8 xs12>
                              <v-text-field
                                ref="bankCharges"
                                v-model="paymentForm.bankCharges"
                                :label="paymentFormLabel.bankCharges"
                                :error-messages="errors.collect('paymentForm.bankCharges')"
                                data-vv-name="paymentForm.bankCharges"
                                :data-vv-as="paymentFormLabel.bankCharges"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'mask_decimal:2|mask_max_value:9999999999999.99'"
                                @blur="calculateAmount()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="paymentForm.bankTotalAmountCurr"
                                :label="paymentFormLabel.bankTotalAmountCurr"
                                disabled
                                item-text="label"
                                item-value="value"
                                data-vv-name="paymentForm.bankTotalAmountCurr"
                                :data-vv-as="paymentFormLabel.bankTotalAmountCurr"
                                :error-messages="errors.collect('paymentForm.bankTotalAmountCurr')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md8 xs12>
                              <v-text-field
                                v-model="paymentForm.bankTotalAmount"
                                :label="paymentFormLabel.bankTotalAmount"
                                disabled
                                :error-messages="errors.collect('bankTotalAmount')"
                                data-vv-name="bankTotalAmount"
                                :data-vv-as="paymentFormLabel.bankTotalAmount"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'entry|max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="paymentForm.bankTotalLocalCurr"
                                disabled
                                :label="paymentFormLabel.bankTotalLocalCurr"
                                item-text="label"
                                item-value="value"
                                data-vv-name="paymentForm.bankTotalLocalCurr"
                                :data-vv-as="paymentFormLabel.bankTotalLocalCurr"
                                :error-messages="errors.collect('paymentForm.bankTotalLocalCurr')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md1 xs12>
                              <v-checkbox
                                color="primary"
                                :label="paymentFormLabel.bankTotalLocalAE"
                                v-model="paymentForm.bankTotalLocalAE"
                                :disabled="isEqual"
                                @change="calculateAmount()"
                              ></v-checkbox>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-text-field
                                ref="bankTotalLocal"
                                v-model="paymentForm.bankTotalLocal"
                                :label="paymentFormLabel.bankTotalLocal"
                                :disabled="isBankTotLoc"
                                :error-messages="errors.collect('paymentForm.bankTotalLocal')"
                                data-vv-name="paymentForm.bankTotalLocal"
                                :data-vv-as="paymentFormLabel.bankTotalLocal"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'entry|max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="paymentForm.chequeNo"
                                :label="paymentFormLabel.chequeNo"
                                :error-messages="errors.collect('paymentForm.chequeNo')"
                                data-vv-name="paymentForm.chequeNo"
                                :data-vv-as="paymentFormLabel.chequeNo"
                                v-validate="chequeNoValidation"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-checkbox color="primary" :label="paymentFormLabel.prtCheque" v-model="paymentForm.prtCheque"></v-checkbox>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6 v-if="isNew">
                              <v-subheader class="queryLabel">{{ paymentFormLabel.createdBy }}</v-subheader>
                              <div class="queryValue">{{ createdName + ' on ' + nowDT }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6 v-else>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.createdBy }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.createdBy + ' on ' + paymentForm.createdDate }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6 v-if="isNew">
                              <v-subheader class="queryLabel">{{ paymentFormLabel.modifiedBy }}</v-subheader>
                              <div class="queryValue">{{ createdName + ' on ' + nowDT }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6 v-else>
                              <v-subheader class="queryLabel">{{ paymentFormLabel.modifiedBy }}</v-subheader>
                              <div class="queryValue">{{ paymentForm.modifiedBy + ' on ' + paymentForm.modifiedDate }}</div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="optional" eager>
                <form data-vv-scope="paymentOptionalForm">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <div class="header-padding body-2">Document Details</div>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-autocomplete
                                :items="printDocOpts"
                                v-model="paymentForm.printDocument"
                                :label="paymentFormLabel.printDocument"
                                item-text="label"
                                item-value="value"
                                data-vv-name="paymentForm.printDocument"
                                :data-vv-as="paymentFormLabel.printDocument"
                                :error-messages="errors.collect('paymentForm.printDocument')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-autocomplete
                                :items="addressToOpts"
                                v-model="paymentForm.addressTo"
                                :label="paymentFormLabel.addressTo"
                                item-text="label"
                                item-value="value"
                                data-vv-name="paymentForm.addressTo"
                                :data-vv-as="paymentFormLabel.addressTo"
                                :error-messages="errors.collect('paymentForm.addressTo')"
                                @change="promptRemoveNameAddr = true"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-text-field
                                v-model="paymentForm.policyNo"
                                :label="paymentFormLabel.policyNo"
                                :error-messages="errors.collect('paymentForm.policyNo')"
                                data-vv-name="paymentForm.policyNo"
                                :data-vv-as="paymentFormLabel.policyNo"
                                v-validate="'entry|max:60'"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="showAcctPolicyHelpList = true">mdi-magnify</v-icon>
                                </v-slide-x-reverse-transition>
                              </v-text-field>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-text-field
                                v-model="paymentForm.companyName"
                                :label="paymentFormLabel.companyName"
                                :error-messages="errors.collect('paymentForm.companyName')"
                                data-vv-name="paymentForm.companyName"
                                :data-vv-as="paymentFormLabel.companyName"
                                v-validate="'entry|max:100|sanction:' + sanctionName1Error"
                                @change="valSanction(paymentForm.companyName, '', 'sanctionName1Error')"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="paymentForm.docAddress1"
                                :label="paymentFormLabel.docAddress1"
                                :error-messages="errors.collect('paymentForm.docAddress1')"
                                data-vv-name="paymentForm.docAddress1"
                                :data-vv-as="paymentFormLabel.docAddress1"
                                v-validate="'max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="paymentForm.docAddress2"
                                :label="paymentFormLabel.docAddress2"
                                :error-messages="errors.collect('paymentForm.docAddress2')"
                                data-vv-name="paymentForm.docAddress2"
                                :data-vv-as="paymentFormLabel.docAddress2"
                                v-validate="'max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="paymentForm.docAddress3"
                                :label="paymentFormLabel.docAddress3"
                                :error-messages="errors.collect('paymentForm.docAddress3')"
                                data-vv-name="paymentForm.docAddress3"
                                :data-vv-as="paymentFormLabel.docAddress3"
                                v-validate="'max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="paymentForm.docAddress4"
                                :label="paymentFormLabel.docAddress4"
                                :error-messages="errors.collect('paymentForm.docAddress4')"
                                data-vv-name="paymentForm.docAddress4"
                                :data-vv-as="paymentFormLabel.docAddress4"
                                v-validate="'max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-text-field
                                v-model="paymentForm.postalCode"
                                :label="paymentFormLabel.postalCode"
                                :error-messages="errors.collect('paymentForm.postalCode')"
                                data-vv-name="paymentForm.postalCode"
                                :data-vv-as="paymentFormLabel.postalCode"
                                v-validate="'numeric|max:8'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="paymentForm.details"
                                :label="paymentFormLabel.details"
                                :error-messages="errors.collect('paymentForm.details')"
                                data-vv-name="paymentForm.details"
                                :data-vv-as="paymentFormLabel.details"
                                v-validate="'entry|max:120'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="paymentForm.statementRef"
                                :label="paymentFormLabel.statementRef"
                                :error-messages="errors.collect('paymentForm.statementRef')"
                                data-vv-name="paymentForm.statementRef"
                                :data-vv-as="paymentFormLabel.statementRef"
                                v-validate="'entry|max:200'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <div class="header-padding body-2">Other Details</div>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-autocomplete
                                :items="departments"
                                v-model="paymentForm.department"
                                :label="paymentFormLabel.department"
                                item-text="label"
                                item-value="value"
                                data-vv-name="paymentForm.department"
                                :data-vv-as="paymentFormLabel.department"
                                :error-messages="errors.collect('paymentForm.department')"
                                v-validate="deptValidation"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="paymentForm.insuredName"
                                :label="paymentFormLabel.insuredName"
                                :error-messages="errors.collect('paymentForm.insuredName')"
                                data-vv-name="paymentForm.insuredName"
                                :data-vv-as="paymentFormLabel.insuredName"
                                v-validate="'entry|max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="paymentForm.claimNo"
                                :label="paymentFormLabel.claimNo"
                                :error-messages="errors.collect('paymentForm.claimNo')"
                                data-vv-name="paymentForm.claimNo"
                                :data-vv-as="paymentFormLabel.claimNo"
                                v-validate="'entry|max:60'"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="showClmHelpList = true">mdi-magnify</v-icon>
                                </v-slide-x-reverse-transition>
                              </v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="paymentForm.gstRegNo"
                                :label="paymentFormLabel.gstRegNo"
                                :error-messages="errors.collect('paymentForm.gstRegNo')"
                                data-vv-name="paymentForm.gstRegNo"
                                :data-vv-as="paymentFormLabel.gstRegNo"
                                v-validate="'entry|max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="paymentForm.taxInvoiceNo"
                                :label="paymentFormLabel.taxInvoiceNo"
                                :error-messages="errors.collect('paymentForm.taxInvoiceNo')"
                                data-vv-name="paymentForm.taxInvoiceNo"
                                :data-vv-as="paymentFormLabel.taxInvoiceNo"
                                v-validate="'entry|max:60'"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
            </v-tabs-items>
            <v-card-actions>
              <v-btn color="error" dark @click.prevent="doCancel">
                {{ actionLabel.cancel }}
                <v-icon dark right>mdi-exit-to-app</v-icon>
              </v-btn>
              <v-btn color="secondary" dark @click="showMatchLater = true">
                {{ actionLabel.matchLater }}
                <v-icon dark right>mdi-content-copy</v-icon>
              </v-btn>
              <v-btn color="info" dark @click.prevent="doSavePayment('CREATE_MATCH_NOW')" :loading="submitting">
                {{ actionLabel.matchNow }}
                <v-icon dark right>mdi-content-copy</v-icon>
              </v-btn>
              <v-btn color="info" dark @click.prevent="doSavePayment('CREATE_SAVE_REVIEW')" :loading="submitting">
                {{ actionLabel.saveAndReview }}
                <v-icon dark right>mdi-content-save</v-icon>
              </v-btn>
              <v-btn color="primary" dark @click.prevent="doSavePayment('CREATE_SAVE_POST')" :loading="submitting">
                {{ actionLabel.saveAndPost }}
                <v-icon dark right>mdi-arrow-right-bold-box</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 v-if="this.paymentData.tranMode === 'R'">
          <!-- CBO Added: Oct-05-2020 Comments -->
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex lg12 xs12 order-lg1 order-xs2>
                <common-comments :commentRefNo="this.commentRefNo" :commentTranType="this.commentTranType"></common-comments>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>

      <v-dialog v-model="showPayToHelpList" width="1280px">
        <acct-no-help-list @close="showPayToHelpList = false" @assign-acct-info="assignAcctInfo"></acct-no-help-list>
      </v-dialog>

      <v-dialog v-model="showBankNoHelpList" width="1280px">
        <bank-help-list @close="showBankNoHelpList = false" @assign-bank-info="assignBankInfo" :objData="bankHelpListScreen"></bank-help-list>
      </v-dialog>

      <v-dialog v-model="showAcctSufHelpList" width="1280px">
        <acct-suf-help-list @close="showAcctSufHelpList = false" @assign-acct-suf-info="assignAcctSufInfo"></acct-suf-help-list>
      </v-dialog>

      <v-dialog v-model="showCurrencyHelpList" width="1280px">
        <currency-help-list @close="showCurrencyHelpList = false" @assign-currency-info="assignCurrencyInfo"></currency-help-list>
      </v-dialog>

      <v-dialog v-model="showAcctPolicyHelpList" width="1280px">
        <acct-policy-help-list
          :accountNo="paymentForm.payTo"
          :boolPolRefresh="showAcctPolicyHelpList"
          @close="showAcctPolicyHelpList = false"
          @assign-policy-info="assignPolicyInfo"
        ></acct-policy-help-list>
      </v-dialog>

      <v-dialog v-model="showClmHelpList" width="1280px">
        <claim-help-list
          @close="showClmHelpList = false"
          @assign-claim-no="assignClaimNo"
          :boolRefresh="showClmHelpList"
          :accountNo="paymentForm.payTo"
        ></claim-help-list>
      </v-dialog>

      <v-dialog v-model="processingFlag" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Processing...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loadingFlag" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Loading...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <warning v-model="promptMsg" :label="errMsg" :showAcceptBtn="isWarning" @ok="acceptInterWarn = true"/>
      <v-dialog v-model="showErrorDialog" width="800px">
        <v-card>
          <v-card-title primary-title>
            <div>
              <div class="headline">System Information</div>
              <span class="grey--text">An error occurred when creating payment.</span>
            </div>
          </v-card-title>
          <v-card-text>
            <div v-if="messages.length > 0" class="pb-3">
              <v-subheader>Error Details:</v-subheader>
              <ul class="showErrorMsgs">
                <li v-for="(error, index) in messages" :key="index">
                  {{ error.message }}
                </li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--LYT Added: 2020-08-27  Sanction Partial Matched Names List -->
      <v-dialog v-model="showSanctionDialog" width="1280px">
        <sanction-partial-match-list :sanctionItems="sanctionPartialMatchItems" @close="showSanctionDialog = false"></sanction-partial-match-list>
      </v-dialog>
      <v-dialog v-model="showMatchLater" width="680px">
        <match-later
          :multiFundSfxCurr="miscacctparams.multiFundSfxCurr"
          :tranType="paymentForm.transactionType"
          :curr="paymentForm.amountCurr"
          :acctNo="paymentForm.accountNo"
          :fund="paymentForm.fund"
          :acctNoSfx="paymentForm.accountNoSuffix"
          :polNo="paymentForm.policyNo"
          :boolRefresh="showMatchLater"
          @close="showMatchLater = false"
          @assign-match-later-info="assignMatchLaterInfo"
        ></match-later>
      </v-dialog>
      <prompt-leave
        v-if="showPromptLeave"
        title="Payment"
        :tranMode="this.paymentData.tranMode"
        v-model="promptLeave"
        @exit="doExit"
        @saveAndExit="doSaveAndExit"
      ></prompt-leave>

      <confirm v-model="promptConfirmation" @ok="doProceed" @cancel="processingFlag = false">
        <p>Cheque No. is existing in other payment, do you want to proceed?</p>
        <div class="queryValue">
          Bank No. : {{ this.paymentForm.fromBank }}<br />
          Cheque No. : {{ this.paymentForm.chequeNo }}<br />
        </div>
      </confirm>
      <confirm v-model="promptRemoveNameAddr" @ok="doRemoveNameAddr">
        {{ promptRemoveNameAddrMsg }}
      </confirm>
    </v-container>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
import MessageMixin from '@/mixins/message'
import { paymentListMixin } from '@/mixins/accounting/payment/paymentListMixin'
import { paymentFilterMixin } from '@/mixins/accounting/payment/paymentFilterMixin'
import { paymentAjaxMixin } from '@/mixins/accounting/payment/paymentAjaxMixin'
import { paymentViewMixin } from '@/mixins/accounting/payment/paymentViewMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import AcctNoHelpList from '@/components/core/common/dialog/AcctNoHelpList'
import BankHelpList from '@/components/core/common/dialog/BankHelpList'
import AcctSufHelpList from '@/components/core/common/dialog/AcctSufHelpList'
import CurrencyHelpList from '@/components/core/common/dialog/CurrencyHelpList'
import { removeFormatNumber } from '@/utils/number'
import AcctPolicyHelpList from '@/components/core/common/dialog/AcctPolicyHelpList'
import ClaimHelpList from '@/components/core/common/dialog/ClaimHelpList'
import { promptOnExitMixin } from '@/mixins/common/promptOnExitMixin'
import PromptLeave from '@/components/core/common/prompt/PromptLeave'
import { formatPrice } from '@/utils/index'
import { parseISO } from 'date-fns'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import SanctionPartialMatchList from '@/components/core/common/dialog/SanctionPartialMatchList'
import MatchLater from '../dialog/MatchLater'
import CommonComments from '@/components/core/accounting/CommonComments'
import isAfter from 'date-fns/isAfter'

export default {
  data() {
    return {
      tabNav: 0,
      actionLabel: {
        cancel: 'Cancel',
        saveAndReview: 'Save & Review',
        saveAndPost: 'Save & Post',
        matchNow: 'Match Now',
        matchCommission: 'Match Commission',
        matchRBC: 'Match RBC',
        matchLater: 'Match Later'
      },
      validStatus: {
        mandatory: true,
        optional: true
      },
      miscacctparams: [],
      cashbooks: [],
      departments: [],
      checkTabData: false,
      loading: false,
      loadingFlag: false,
      processingFlag: false,
      showErrorDialog: false,
      submitting: false,
      showPromptLeave: true,
      isMandatory: true,
      isOptional: false,
      accounts: [],
      accountdata: {},
      banks: [],
      bankdata: {},
      acctnosuffixes: [],
      acctnosuffixdata: {},
      amountcurrencies: [],
      amountcurrencydata: {},
      trandaterange: {},
      gstStatuses: [],
      branches: [],
      funds: [],
      gstrate: '0.00',
      chequeNoForm: null,
      promptConfirmation: false,
      isExistChequeNo: false,
      actionName: null,
      currencyrate: {},
      showMatchLater: false,
      promptRemoveNameAddr: false,
      promptRemoveNameAddrMsg: 'Do you want to remove Name, Address(1-4), Postal Code?',
      payBankCurr: false
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function(messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    },
    'tDateRange.effDate': function() {
      if (this.tDateRange.effDate !== '' && this.paymentData.tranMode === '') {
        this.loading = true
        this.getCommonData('gstrate', this.paymentForm.gstStatus, formatDisplayDateTime2(this.paymentForm.transactionDate)).then(result => {
          if (result) {
            this.loading = false
          }
        })
      }
    },
    'paymentForm.amountCurr': function() {
      if (this.paymentForm.amountCurr && this.paymentForm.transactionDate) {
        this.getCommonData('currencyrate', this.paymentForm.amountCurr, formatDisplayDateTime2(this.paymentForm.transactionDate))
      }
    },
    'paymentForm.transactionDate': function() {
      if (this.paymentForm.amountCurr && this.paymentForm.transactionDate) {
        this.getCommonData('currencyrate', this.paymentForm.amountCurr, formatDisplayDateTime2(this.paymentForm.transactionDate))
        this.getCommonData('bankcurrencyrate', this.paymentForm.fromBank, formatDisplayDateTime2(this.paymentForm.transactionDate))
      }
    }
  },
  computed: {
    doValidateTranDate() {
      const minDate = this.tDateRange.effDate
      const today = this.tDateRange.expDate
      return 'required|valMinTranDate:' + minDate + '|valMaxTranDate:' + today
    },
    paymentData() {
      return this.$store.state.payment.paymentData
    },
    displayErrorDialog() {
      return this.messages
    },
    isGstAmtAE: function() {
      return this.paymentForm.gstIO === 'B'
    },
    isBlankGSTIO: function() {
      return this.paymentForm.gstIO === 'B'
    },
    isDisabledDocNo: function() {
      return this.paymentForm.docAE
    },
    token() {
      return this.$store.state.token
    },
    isCashBook: function() {
      return this.miscacctparams.cashBkMand === null || this.miscacctparams.cashBkMand === false
    },
    isGstAmt: function() {
      return this.paymentForm.gstAmountAE
    },
    isBankAmt: function() {
      return this.paymentForm.bankAmountAE
    },
    isBankTotLoc: function() {
      return this.paymentForm.bankTotalLocalAE
    },
    docNoValidation() {
      if (this.paymentForm.docAE === false && (this.paymentForm.documentNo === null || this.paymentForm.documentNo === '')) {
        return 'required'
      } else {
        return 'entry|documentNo:' + this.paymentForm.isExistDocNo
      }
    },
    chequeNoValidation() {
      if (parseInt(this.chequeNoForm) === 0) {
        return 'required|max:10'
      } else if (this.chequeNoForm > 0) {
        return 'entry|chequeNo:' + this.chequeNoForm
      } else {
        return ''
      }
    },
    deptValidation() {
      if (this.miscacctparams.deptMand) {
        return 'required'
      } else {
        return ''
      }
    },
    tDateRange() {
      return this.trandaterange
    },
    apiURI() {
      return this.$store.state.payment.menu
    },
    commentRefNo() {
      const data = this.$store.state.payment.paymentData
      return data.accountNo + data.documentNo + data.fund + data.suffix + data.branch + data.type
    },
    commentTranType() {
      return this.$store.state.payment.paymentData.type
    },
    isEqual: function() {
      if (
        this.paymentForm.amountCurr === this.paymentForm.bankAmountCurr &&
        this.paymentForm.bankAmountCurr === this.paymentForm.bankTotalLocalCurr
      ) {
        return true
      } else {
        return false
      }
    },
    isNew() {
      return !(this.paymentData.tranMode === 'Q' || this.paymentData.tranMode === 'R')
    }
  },
  methods: {
    async doInit() {
      this.loadingFlag = true
      await Promise.all([this.$store.dispatch('commonsInit')])
      await Promise.all([this.$store.dispatch('paymentInit')])
      await Promise.all([this.$store.dispatch('reportsInit')])
      await Promise.all([this.$store.dispatch('acctReportsInit')])
      this.getAcctPaytVouMenuLink()
      this.getCommonData('miscacctparams', 'cash')
      this.getCommonData('miscacctparams').then(() => {
        this.paymentForm.printDocument = this.miscacctparams.defIlnpv
      })
      this.getChequeNoForm()
      this.getCommonData('trandaterange', '004')
      this.bankHelpListScreen = 'screen_1'
      this.definePaymentMode()
      this.getBaseCurr(this.paymentForm)
      this.fetchBranch()
      this.fetchFund()
      this.fetchBank()
      this.fetchAcctNoSfx()
      this.fetchGstStatus()
      this.fetchCurrency()
      this.fetchAmountCurrency()
      this.fetchDepartment()
      this.fetchCashBook()
      this.fetchAccount().then(() => {
        this.loadingFlag = false
      })
    },
    async definePaymentMode() {
      if (this.paymentData.tranMode === 'R') {
        await Promise.all([this.performReview()])
      } else {
        this.getDefaultBankNo(this.token.userBranch, this.paymentForm, 'payment')
        this.paymentForm.transactionDate = new Date()
        this.paymentForm.branch = this.token.userBranch
        this.paymentForm.gstIO = 'B'
        this.paymentForm.gstStatus = 'N'
        this.paymentForm.gstAmountAE = true
        this.paymentForm.bankAmountAE = true
        this.paymentForm.bankTotalLocalAE = true
        this.paymentForm.addressTo = 'A'
      }
    },
    doProceed() {
      this.promptConfirmation = false
      this.doSave()
    },
    checkDocNo() {
      this.isDocNoExist(this.paymentForm)
    },
    checkDocAE(event) {
      if (event) {
        this.paymentForm.documentNo = null
        this.resetMessages()
        this.resetValidator()
      }
    },
    currencyChange() {
      this.paymentForm.gstAmountCurr = this.paymentForm.amountCurr
      this.paymentForm.netAmountCurr = this.paymentForm.amountCurr
    },
    changeGstIO(gstIO) {
      this.paymentForm.gstIO = gstIO
      if (this.paymentForm.gstIO === 'B') {
        this.paymentForm.gstStatus = 'B'
        this.paymentForm.gstAmount = (0.0).toFixed(2)
        this.paymentForm.gstRate = (0.0).toFixed(2)
      } else {
        this.paymentForm.gstStatus = 'M'
        this.getCommonData('gstrate', this.paymentForm.gstStatus, formatDisplayDateTime2(this.paymentForm.transactionDate))
      }
      this.calculateAmount()
    },
    changeGstRate(gstStatus) {
      this.getCommonData('gstrate', gstStatus, formatDisplayDateTime2(this.paymentForm.transactionDate))
    },
    setAmount() {
      this.$refs.amount.$el.cleave.setRawValue(this.paymentForm.amount)
      this.paymentForm.amount = formatPrice(this.$refs.amount.$el.cleave.getRawValue())
      this.$refs.gstAmount.$el.cleave.setRawValue(this.paymentForm.gstAmount)
      this.paymentForm.gstAmount = formatPrice(this.$refs.gstAmount.$el.cleave.getRawValue())
      this.$refs.bankAmount.$el.cleave.setRawValue(this.paymentForm.bankAmount)
      this.paymentForm.bankAmount = formatPrice(this.$refs.bankAmount.$el.cleave.getRawValue())
      this.$refs.bankCharges.$el.cleave.setRawValue(this.paymentForm.bankCharges)
      this.paymentForm.bankCharges = formatPrice(this.$refs.bankCharges.$el.cleave.getRawValue())
      this.$refs.bankTotalLocal.$el.cleave.setRawValue(this.paymentForm.bankTotalLocal)
      this.paymentForm.bankTotalLocal = formatPrice(this.$refs.bankTotalLocal.$el.cleave.getRawValue())
    },
    doMandatory(tabId) {
      if (this.isMandatory === false) {
        this.$validator.validateAll('paymentOptionalForm').then(result => {
          if (result) {
            this.isMandatory = true
            this.isOptional = false
            this.validStatus.optional = true
            this.validStatus.mandatory = true
            this.tabNav = tabId
          } else {
            if (this.isMandatory === true && this.isOptional === false) {
              this.validStatus.optional = true
              this.tabNav = 0
            } else {
              this.validStatus.optional = false
              this.tabNav = 1
            }
          }
        })
      }
    },
    doOptinoalA() {
      if (this.isMandatory === false && this.isOptional === true) {
        this.validStatus.mandatory = true
        this.tabNav = 1
      } else {
        this.validStatus.mandatory = false
        this.tabNav = 0
      }
    },
    doOptional(tabId) {
      if (this.isOptional === false) {
        this.$validator.validateAll('paymentMandatoryForm').then(result => {
          if (result) {
            this.ValidateTranDateRange(this.paymentForm.transactionDate, '004').then(result => {
              if (result) {
                if (this.paymentData.tranMode !== 'R') {
                  this.validateIntermediary(this.paymentForm.transactionDate, this.paymentForm.payTo).then(() => {
                    if (this.promptMsg === false || this.acceptInterWarn === true) {
                      this.isMandatory = false
                      this.isOptional = true
                      this.validStatus.mandatory = true
                      this.validStatus.optional = true
                      this.tabNav = tabId
                    } else {
                      this.doOptinoalA()
                    }
                  })
                } else {
                  this.isMandatory = false
                  this.isOptional = true
                  this.validStatus.mandatory = true
                  this.validStatus.optional = true
                  this.tabNav = tabId
                }
              } else {
                this.doOptinoalA()
              }
            })
          } else {
            this.doOptinoalA()
            this.promptFieldCheck()
          }
        })
      }
    },
    calculateAmount() {
      let bankAmt = 0.0
      let bankTotAmt = 0.0
      if (this.paymentForm.gstAmountAE) {
        this.paymentForm.gstAmount = formatPrice((removeFormatNumber(this.paymentForm.amount) * this.paymentForm.gstRate) / 100)
      }

      if (this.paymentForm.gstIO === 'B') {
        this.paymentForm.netAmount = formatPrice(Number(removeFormatNumber(this.paymentForm.amount)))
      } else if (this.paymentForm.gstIO === 'I') {
        this.paymentForm.netAmount = formatPrice(
          Number(removeFormatNumber(this.paymentForm.amount)) + Number(removeFormatNumber(this.paymentForm.gstAmount))
        )
      } else if (this.paymentForm.gstIO === 'O') {
        this.paymentForm.netAmount = formatPrice(
          Number(removeFormatNumber(this.paymentForm.amount)) - Number(removeFormatNumber(this.paymentForm.gstAmount))
        )
      }

      if (this.paymentForm.bankAmountAE) {
        this.paymentForm.bankAmount = formatPrice(
          (removeFormatNumber(this.paymentForm.netAmount) * this.paymentForm.amountCurrRate) / this.paymentForm.bankAmountCurrRate
        )
      }

      this.paymentForm.bankTotalAmount = formatPrice(
        Number(removeFormatNumber(this.paymentForm.bankAmount)) + Number(removeFormatNumber(this.paymentForm.bankCharges))
      )

      if (this.paymentForm.bankTotalLocalAE) {
        if (this.paymentForm.bankAmountAE) {
          bankAmt =
            (Number(removeFormatNumber(this.paymentForm.netAmount)) * Number(removeFormatNumber(this.paymentForm.amountCurrRate))) /
            Number(removeFormatNumber(this.paymentForm.bankAmountCurrRate))
        } else {
          bankAmt = removeFormatNumber(this.paymentForm.bankAmount)
        }
        bankTotAmt = Number(bankAmt) + Number(removeFormatNumber(this.paymentForm.bankCharges))
        bankTotAmt = bankTotAmt * Number(this.paymentForm.bankAmountCurrRate)
        this.paymentForm.bankTotalLocal = formatPrice(bankTotAmt)
      }
      this.setAmount()
    },
    checkChequeNo() {
      if (this.paymentForm.chequeNo !== null && this.paymentForm.chequeNo !== '') {
        this.getAcctMasterPaytChequeNo(this.paymentForm).then(result => {
          if (result) {
            if (this.isExistChequeNo === 'true') {
              this.promptConfirmation = true
            } else {
              this.doSave()
            }
          }
        })
      } else {
        this.doSave()
      }
    },
    doCancel() {
      this.$router.push({ name: 'payment' }).catch(() => {})
    },
    doSavePayment(actionName) {
      this.processingFlag = true
      this.actionName = actionName
      this.checkChequeNo()
    },
    doSave() {
      if (this.paymentData.tranMode === 'R') {
        if (this.actionName === 'CREATE_SAVE_REVIEW') {
          this.actionName = 'UPDATE_SAVE_REVIEW'
        } else if (this.actionName === 'CREATE_SAVE_POST') {
          this.actionName = 'UPDATE_SAVE_POST'
        } else if (this.actionName === 'CREATE_MATCH_NOW') {
          this.actionName = 'UPDATE_MATCH_NOW'
        } else if (this.actionName === 'CREATE_MATCH_LATER') {
          this.actionName = 'UPDATE_MATCH_LATER'
        }
      }
      this.paymentForm.bankNo = this.paymentForm.fromBank

      this.$validator.validateAll('paymentMandatoryForm').then(result => {
        if (result) {
          this.ValidateTranDateRange(this.paymentForm.transactionDate, '004').then(result => {
            if (result) {
              this.validateIntermediary(this.paymentForm.transactionDate, this.paymentForm.payTo).then(() => {
                if (this.promptMsg === false || this.acceptInterWarn === true) {
                  this.$validator.validateAll('paymentOptionalForm').then(result => {
                    if (result) {
                      this.isMandatory = true
                      this.isOptional = false
                      this.processingFlag = true
                      this.paymentForm.actionName = this.actionName
                      this.performSave()
                    } else {
                      this.validStatus.optional = false
                      this.processingFlag = false
                      this.tabNav = 1
                    }
                  })
                } else {
                  this.validStatus.optional = false
                  this.processingFlag = false
                  this.tabNav = 0
                }
              })
            } else {
              this.validStatus.mandatory = false
              this.tabNav = 0
              this.processingFlag = false
            }
          })
        } else {
          this.validStatus.mandatory = false
          this.tabNav = 0
          this.processingFlag = false
          this.promptFieldCheck()
        }
      })
    },
    parseDateISO(value) {
      if (value) {
        return parseISO(value)
      }
    },
    assignAcctInfo(data) {
      this.paymentForm.payTo = data.inter
      if (this.paymentForm.addressTo === 'A') {
        this.paymentForm.accountNo = data.inter
        this.paymentForm.gstRegNo = data.gstRegNo
        this.paymentForm.companyName = data.name
        this.paymentForm.docAddress1 = data.address1
        this.paymentForm.docAddress2 = data.address2
        this.paymentForm.docAddress3 = data.address3
        this.paymentForm.docAddress4 = data.address4
        this.paymentForm.postalCode = data.postalCode
      }
      this.showPayToHelpList = false
    },
    assignBankInfo(data) {
      this.paymentForm.bankNo = data.defPayBank
      this.paymentForm.fromBank = data.defPayBank
      this.paymentForm.fund = data.bankFund
      this.paymentForm.accountNoSuffix = data.bankAcctNoSfx
      this.paymentForm.amountCurr = data.bankAcctCurrency
      this.paymentForm.amountCurrRate = data.bankCurrRate
      this.paymentForm.gstAmountCurr = data.bankAcctCurrency
      this.paymentForm.netAmountCurr = data.bankAcctCurrency
      this.paymentForm.bankAmountCurr = data.bankAcctCurrency
      this.paymentForm.bankAmountCurrRate = data.bankCurrRate
      this.paymentForm.bankChargesCurr = data.bankAcctCurrency
      this.paymentForm.bankTotalAmountCurr = data.bankAcctCurrency
      this.payBankCurr = data.payBankCurr
      this.showBankNoHelpList = false
      this.calculateAmount()
    },
    assignAcctSufInfo(data) {
      this.paymentForm.accountNoSuffix = data.acctNoSfx
      this.showAcctSufHelpList = false
    },
    assignCurrencyInfo(data) {
      this.paymentForm.amountCurr = data.curr
      this.paymentForm.gstAmountCurr = data.curr
      this.paymentForm.netAmountCurr = data.curr
      this.paymentForm.amountCurrRate = data.currRate
      this.showCurrencyHelpList = false

      this.calculateAmount()
    },
    assignPolicyInfo(data) {
      this.paymentForm.policyNo = data.policyNo + '-' + data.renCnt + '-' + data.endtCnt
      this.paymentForm.insuredName = data.insuredName
      this.paymentForm.insdRefNo = data.insdRefNo
      if (this.paymentForm.addressTo === 'I') {
        this.paymentForm.companyName = data.fullName
        this.paymentForm.docAddress1 = data.address1
        this.paymentForm.docAddress2 = data.address2
        this.paymentForm.docAddress3 = data.address3
        this.paymentForm.docAddress4 = data.address4
        this.paymentForm.postalCode = data.postalCode
      }
      this.showAcctPolicyHelpList = false
    },
    assignClaimNo(claimNo) {
      this.paymentForm.claimNo = claimNo
      this.showClmHelpList = false
    },
    assignGSTRate(data) {
      this.paymentForm.gstRate = formatPrice(data)
      this.calculateAmount()
    },
    doRemoveNameAddr() {
      this.paymentForm.companyName = ''
      this.paymentForm.docAddress1 = ''
      this.paymentForm.docAddress2 = ''
      this.paymentForm.docAddress3 = ''
      this.paymentForm.docAddress4 = ''
      this.paymentForm.postalCode = ''
    },
    async getPayToAcctInfo(acctNo) {
      this.getCommonData('accountdata', acctNo)
    },
    async getBankInfo(bankNo) {
      this.getCommonData('bankdata', bankNo, formatDisplayDateTime2(this.paymentForm.transactionDate))
    },
    async getAcctNoSfxInfo(acctNoSfx) {
      this.getCommonData('acctnosuffixdata', acctNoSfx)
    },
    assignBankCurrRate(data) {
      this.paymentForm.bankAmountCurrRate = data.bankCurrRate
      this.calculateAmount()
    },
    assignCurrRate(currRate) {
      this.paymentForm.amountCurrRate = currRate
      this.paymentForm.gstAmountCurr = this.paymentForm.amountCurr
      this.paymentForm.netAmountCurr = this.paymentForm.amountCurr
      this.calculateAmount()
    },
    assignMatchLaterInfo(data) {
      this.paymentForm.bmAcctNo = data.bmAcctNo
      this.paymentForm.bmAcctNoSfx = data.bmAcctNoSfx
      this.paymentForm.bmBrn = data.bmBrn
      this.paymentForm.bmFund = data.bmFund
      this.paymentForm.bmTranType = data.bmTranType
      this.paymentForm.bmDocNo = data.bmDocNo
      this.showMatchLater = false
      this.doSavePayment('CREATE_MATCH_LATER')
    }
  },
  created() {
    this.$validator.extend('documentNo', {
      getMessage(field, args) {
        return 'This document no. is exist.'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var isdocNoExist = args[0]
        if (isdocNoExist === 'true') {
          return false
        } else {
          return true
        }
      }
    })
    this.$validator.extend('chequeNo', {
      getMessage(field, args) {
        return 'This Cheque No. exceed Cheque No. Form'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var cheqNoForm = args[0]
        if (cheqNoForm > 0) {
          if (value.length > cheqNoForm) {
            return false
          } else {
            return true
          }
        }
      }
    })
    this.$validator.extend('valMaxTranDate', {
      getMessage(field, args) {
        return 'This date cannot be greater than the date range ' + formatDisplayDate(args[0])
      },
      validate(value, args) {
        let maxDate = args[0]
        if (value) {
          return !isAfter(removeTime(value), removeTime(maxDate))
        } else return true
      }
    })
    this.$validator.extend('valMinTranDate', {
      getMessage(field, args) {
        return 'This date cannot be lesser than the date range ' + formatDisplayDate(args[0])
      },
      validate(value, args) {
        let minDate = args[0]
        if (value) {
          return !isAfter(removeTime(minDate), removeTime(value))
        } else return true
      }
    })
  },
  mounted() {
    this.doInit()
  },
  mixins: [routeMixin, MessageMixin, paymentListMixin, paymentAjaxMixin, paymentFilterMixin, paymentViewMixin, commonAjaxMixin, promptOnExitMixin],
  components: {
    AcctNoHelpList,
    BankHelpList,
    AcctSufHelpList,
    CurrencyHelpList,
    AcctPolicyHelpList,
    ClaimHelpList,
    PromptLeave,
    SanctionPartialMatchList,
    MatchLater,
    CommonComments
  }
}
</script>
<style lang="scss">
@import '../../../../assets/scss/accounting.scss';
</style>
